export var getStatusLabel = function getStatusLabel(status) {
  if (!status) return "Scheduled";
  return status.replace(/_/g, " ").split(" ").map(function (word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }).join(" ");
};